$ = jQuery;
var get_template_directory_uri = window.location.origin + '/wp-content/themes/paraeles';
var urlParams = new URLSearchParams(window.location.search);
var searchParam = urlParams.get('search');

function searchVideos() {
  showLoading();
  //console.log('== SEARCH ==');
  wtv.videos.search([searchParam, 1, 12], function (lastvideosData) {

    /** SE A BUSCA RETORNAS REGISTROS */
    if (lastvideosData.Itens[0]) {

      //console.log(lastvideosData);
      lastvideosData["playlistTitle"] = searchParam;
      for (i = 0; i < lastvideosData.Itens.length; i++) {
        lastvideosData.Itens[i]["playlistTitle"] = searchParam;
      }

      $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
        setTimeout(function () {
          $(".mCustomScrollbar").mCustomScrollbar("destroy").removeClass("mCS_destroyed").addClass("mCustomScrollbar");
          $('#div-thumbs-video').empty().mustache('tpl-thumbs-video', lastvideosData).promise().done(function () {
            initMalihuScrollbar('Nova Playlist');
          });

          // Abre o primeiro vídeo da playlist escolhida
          if (lastvideosData.Itens[0]['Hash']) {
            showSingleVideo(lastvideosData.Itens[0]['Hash'], '');
            showPlayLists(true);
          }
        }, 1500);
      });

    } else {
      /** NENHUM VÍDEO ENCONTRADO */
      $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
        $('#div-single-video').empty().mustache('tpl-no-videos', searchParam);
      });

    }


  });
}


function showPlayLists(visible) {
  if (visible) {
    //console.log('== PLAYLISTS ==');
    wtv.playlists.get([1, 5], function (playlistsData) {
      //console.log(playlistsData);
      $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
        $('#playlists').mustache('tpl-playlists', playlistsData);
      });
    });
  } else {
    // $('.container-playlists').hide();
  }

}

function showLastVideos(page, qtd) {
  // console.log('== LASTVIDEOS ==');
  wtv.videos.get([page, qtd], function (lastvideosData) {
    for (i = 0; i < lastvideosData.Itens.length; i++) {
      lastvideosData.Itens[i]["playlistTitle"] = 'ÚLTIMAS';
      if(lastvideosData.Itens[i].Thumbnail.medium.match('^http://')) {
        lastvideosData.Itens[i].Thumbnail.medium = lastvideosData.Itens[i].Thumbnail.medium.replace(/^http:\/\//i, 'https://');
      }
    }
    // console.log(lastvideosData);
    $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
      $('.ver-mais-videos').hide();
      $('#last-videos').mustache('tpl-last-videos', lastvideosData);
    });
  });
}

var videoPage = 2;

function readMoreVideos() {
  sendTraker();
  showLastVideos(videoPage, 12);
  videoPage++;
}


function showLastSingleVideo() {
  //console.log('== LAST SINGLE VIDEO ==');
  showLoading();
  wtv.videos.get([1, 1], function (singlevideoData) {

    /** Previnir o retorono de N registros (Exemplo: SAPO e YOUON) */
    if (Array.isArray(singlevideoData.Itens)) {
      //console.log(singlevideoData);
      first_singlevideoData = singlevideoData.Itens[0];
    }

    //console.log( first_singlevideoData );

    first_singlevideoData["playlistTitle"] = 'ÚLTIMAS';
    first_singlevideoData["slug"] = getFullURL('ultimas', first_singlevideoData['Title'], first_singlevideoData['Hash']);
    // Synopse = first_singlevideoData["Synopse"];
    // first_singlevideoData["Synopse"] = Synopse.replace(/[^a-zA-ZáàãâéêíóôõúüçÁÀÃÂÉÊÍÓÔÕÚÜÇ0-9/s]/g, ' ');


    $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
      setTimeout(function () {
        $(".mCustomScrollbar").mCustomScrollbar("destroy").removeClass("mCS_destroyed").addClass("mCustomScrollbar");
        $('#div-single-video').empty().mustache('tpl-single-video', first_singlevideoData).promise().done(function () {
          initMalihuScrollbar('Nova Playlist');
        });
        videoSEO(first_singlevideoData, searchParam);

      }, 1500);
    });
  });
}

var videoId;


function showSingleVideo(segment_hash, playlist_title, isToSendTraker) {

  //console.log('== SINGLE VIDEOf ==', isToSendTraker);

  showLoading();
  $('html, body').animate({scrollTop: 0}, 'slow');
  wtv.videos.byHash({"Hash": segment_hash}, function (singlevideoData) {

    //console.log('isArray: ' + Array.isArray(singlevideoData.Itens) );

    singlevideoData.Itens["playlistTitle"] = playlist_title;
    singlevideoData.Itens["slug"] = getFullURL('ultimas', singlevideoData.Itens['Title'], singlevideoData.Itens['Hash']);

    //console.log(singlevideoData.Itens['Title']);
    // Synopse = singlevideoData.Itens["Synopse"];
    // singlevideoData.Itens["Synopse"] = Synopse.replace(/[^a-zA-ZáàãâéêíóôõúüçÁÀÃÂÉÊÍÓÔÕÚÜÇ0-9/s\.\,\!\?]/g, ' ');

    $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
      $('#div-single-video').empty().mustache('tpl-single-video', singlevideoData.Itens);
      videoSEO(singlevideoData.Itens, '');
      if(isToSendTraker != false)
      {
        sendTraker(singlevideoData.Itens['Title']);
      }

      videoId = singlevideoData.Itens.Id;
      $('#div-thumbs-video .video-item').show();
      $('#div-thumbs-video #video-' + videoId).parent().parent().parent().hide();
    });
  });
}

function showThumbsRight(playlist_id, playlist_title) {

  showLoading();

  if (typeof playlist_id !== 'undefined') {

    //console.log('== THUMBS COLUNA DIREITA == PLAYLIST ESCOLHIDA: ' + playlist_id);

    $('html, body').animate({scrollTop: 0}, 'slow');

    wtv.playlists.videos({"playlist_id": playlist_id, 0: [1, 10]}, function (thumbsData) {

      //console.log(thumbsData);

      thumbsData["playlistTitle"] = playlist_title;
      for (i = 0; i < thumbsData.Itens.length; i++) {
        thumbsData.Itens[i]["playlistTitle"] = playlist_title;
        if(thumbsData.Itens[i].Thumbnail.medium.match('^http://')) {
          thumbsData.Itens[i].Thumbnail.medium = thumbsData.Itens[i].Thumbnail.medium.replace(/^http:\/\//i, 'https://');
        }
      }

      $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {

        setTimeout(function () {

          $(".mCustomScrollbar").mCustomScrollbar("destroy").removeClass("mCS_destroyed").addClass("mCustomScrollbar");
          $('#div-thumbs-video').empty().mustache('tpl-thumbs-video', thumbsData).promise().done(function () {
            initMalihuScrollbar('Nova Playlist');
          });

          // Abre o primeiro vídeo da playlist escolhida
          if (thumbsData.Itens[0]['Hash']) {
            showSingleVideo(thumbsData.Itens[0]['Hash'], playlist_title);
          }
        }, 1500);
      });
    });


  } else {

    //console.log('== THUMBS COLUNA DIREITA == PLAYLIST PADRÃO');

    wtv.videos.get([1, 12], function (thumbsData) {

      //console.log(thumbsData);

      for (i = 0; i < thumbsData.Itens.length; i++) {
        thumbsData.Itens[i]["playlistTitle"] = 'ÚLTIMAS';
        if(thumbsData.Itens[i].Thumbnail.medium.match('^http://')) {
          thumbsData.Itens[i].Thumbnail.medium = thumbsData.Itens[i].Thumbnail.medium.replace(/^http:\/\//i, 'https://');
        }
      }

      $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
        $('#div-thumbs-video').mustache('tpl-thumbs-video', thumbsData).promise().done(function () {
          initMalihuScrollbar('Playlist Padrão');
          if (videoId) {
            $('#div-thumbs-video .video-item').show();
            $('#div-thumbs-video #video-' + videoId).parent().parent().parent().hide();
          }
        });
      });
    });

  }

}

function showLoading() {
  $.Mustache.load(get_template_directory_uri + '/dist/mustache/tpl-videos.html', function () {
    $('#div-single-video').empty().mustache('tpl-loading');
  });
}

function initMalihuScrollbar(txt) {

  //console.log('initMalihuScrollbar: ' + txt);
  $(".mCustomScrollbar").mCustomScrollbar({
    scrollButtons: {
      enable: true
    },
    theme: "light-thick",
    live: "true",
    advanced: {
      autoExpandHorizontalScroll: true
    }
  });
}

ShareVid = {
  facebook: function (purl, ptitle, pimg, text) {
    url = 'https://www.facebook.com/sharer.php?s=100';
    url += '&u=' + encodeURIComponent(purl);
    url += '&p[title]=' + encodeURIComponent(ptitle);
    url += '&p[summary]=' + encodeURIComponent(text);
    url += '&p[url]=' + encodeURIComponent(purl);
    url += '&p[images][0]=' + encodeURIComponent(pimg);
    ShareVid.popup(url);
  },
  twitter: function (purl, ptitle) {
    url = 'https://twitter.com/share?';
    url += 'text=' + encodeURIComponent(ptitle);
    url += '&url=' + encodeURIComponent(purl);
    url += '&counturl=' + encodeURIComponent(purl);
    ShareVid.popup(url);
  },
  pinterest: function (purl, pimg, text) {
    var url = "";
    url = 'https://pinterest.com/pin/create/bookmarklet/?';
    url += 'media=' + encodeURIComponent(pimg);
    url += '&url=' + encodeURIComponent(purl);
    url += 'description=' + encodeURIComponent(text);
    ShareVid.popup(url);

  },
  popup: function (url) {
    window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
  }
};

$(window).load(function () {
  var pubVideoH = $('.mrec-video').offset();

  function mrecVideoPos() {

    var ultimosH = $('#ultimos-videos').height();
    var pubVideoHeight = $('.mrec-video iframe').height();
    if (pubVideoH === undefined) return;
    var sizeSingleDif = pubVideoH.top + ultimosH - pubVideoHeight + 144;


    if ($(window).scrollTop() > pubVideoH.top - 60) {
      if ($(window).scrollTop() > sizeSingleDif - 20) {
        $('.mrec-video').css({
          position: 'fixed',
          top: 70
        });
      } else {
        $('.mrec-video').css({
          position: 'fixed',
          top: 70
        });
      }
    } else {
      $('.mrec-video').css({
        position: 'relative',
        top: 0
      });
    }
  }

  $(window).scroll(function () {
    mrecVideoPos();
  });

  mrecVideoPos();
});

function string_to_slug(str) {

  str = str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaaaeeeeiiiioooouuuunc------";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes
    .replace(/^-+/, "") // trim - from start of text
    .replace(/-+$/, ""); // trim - from end of text

  return str;
}

function videoSEO(singlevideoData, searchParam) {

  $("meta[property='og\\:title']").attr("content", singlevideoData.Title);
  $("meta[property='og\\:url']").attr("content", singlevideoData.slug);
  $("meta[property='og\\:image']").attr("content", singlevideoData.Thumbnail.medium);
  $("meta[property='og\\:description']").attr("content", singlevideoData.Synopse);
  if (searchParam) {
    //console.log('SEARCH: ' + searchParam);
  } else {
    window.history.pushState("", "", getFullURL(singlevideoData.playlistTitle, singlevideoData.Title, singlevideoData.Hash));
  }
}

function getFullURL(playlistTitle, Title, Hash) {
  var pathNivelPlayList = string_to_slug(playlistTitle);
  var pathTitleSlug = string_to_slug(Title);
  var url = window.location.origin + "/lista-videos/" + pathNivelPlayList + "/" + pathTitleSlug + '/' + Hash;
  return url;
}

/** SEARCH  */
$('#search-videos').on('keyup', function (e) {
  if (e.keyCode === 13) {
    search_videos();
  }
});

function search_videos() {
  var query = $("#search-videos").val();
  var host = window.location.host;

  url = '//' + host + '/lista-videos/?search=' + query;
  window.location.href = url;
}
